import Folder from './folder';

export default class SharedFolder extends Folder {
	constructor( { customBranding, ...folderAttributes } ) {
		super( folderAttributes );

		this.customBranding = customBranding;
	}

	static fromJSON( properties ) {
		const folder = super.fromJSON( properties );
		folder.customBranding = properties?.custom_branding;

		return folder;
	}

	toJSON() {
		return {
			...super.toJSON(),
			custom_branding: this.customBranding
		};
	}
}
